import { createClient } from "@supabase/supabase-js";

// Note: not parameterized with <Database> — the shared Database type does not yet
// describe the platform-specific tables (klubora_platform_users, tenant_lifecycle_events,
// platform_audit_log, etc.). Hooks cast their own result rows.

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY in apps/platform/.env");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
